import React, { useEffect, useState } from 'react';
import { Rocket, X } from 'lucide-react';

const STORAGE_KEY = 'pp_banner_dismissed_v1';

const AnnouncementBar = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let dismissed = false;
    try { dismissed = sessionStorage.getItem(STORAGE_KEY) === '1'; } catch (_) {}
    if (!dismissed) setVisible(true);
  }, []);

  const close = () => {
    try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (_) {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="relative z-[55] w-full bg-[#111111] text-white">
      <div className="max-w-[1240px] mx-auto px-6 sm:px-8 lg:px-10 py-2.5 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <span className="inline-flex items-center gap-1.5 h-6 px-2.5 rounded-full bg-white/10 text-[10.5px] font-semibold tracking-[0.14em] uppercase">
            <Rocket className="w-3 h-3 text-[#A79BF3]" strokeWidth={2.6} />
            Info
          </span>
          <p className="text-[12.5px] sm:text-[13px] text-white/85 truncate">
            Unsere Website befindet sich im Umbau – wir sind wie gewohnt telefonisch und per E-Mail erreichbar.
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <a
            href="tel:+4915153764622"
            className="hidden sm:inline-flex items-center gap-1.5 text-[12.5px] font-semibold text-white hover:text-[#A79BF3] transition"
          >
            015153764622
          </a>
          <button
            type="button"
            aria-label="Hinweis schließen"
            onClick={close}
            className="w-6 h-6 rounded-full flex items-center justify-center text-white/70 hover:text-white hover:bg-white/10 transition"
          >
            <X className="w-3.5 h-3.5" strokeWidth={2.4} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBar;
